import { api1C } from './api';

export const load1cAgreements = (params) => {
    return api1C.get(`agreements`, {
        params,
    });
}
    
